export default class ResponsiveHelper {

    static isMobile() {
        var element = document.querySelector("#responsive__state .mobile");
        if (element) {
            var style = window.getComputedStyle(element);
            return style.display == "block";
        }

        return false;
    }
    static isTablet() {
        var element = document.querySelector("#responsive__state .tablet");
        if (element) {
            var style = window.getComputedStyle(element);
            return style.display == "block";
        }

        return false;
    }

    static isTabletls() {
        var element = document.querySelector("#responsive__state .tablet-ls");
        if (element) {
            var style = window.getComputedStyle(element);
            return style.display == "block";
        }

        return false;
    }

    static isDesktop() {
        var element = document.querySelector("#responsive__state .desktop");
        if (element) {
            var style = window.getComputedStyle(element);
            return style.display == "block";
        }

        return false;
    }
}